import { render } from "./VoteClock.vue?vue&type=template&id=c954ed38&scoped=true"
import script from "./VoteClock.vue?vue&type=script&lang=js"
export * from "./VoteClock.vue?vue&type=script&lang=js"

import "./VoteClock.vue?vue&type=style&index=0&id=c954ed38&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c954ed38"

export default script